module.exports = __webpack_public_path__ + "static/media/cloud-3.df2caee7.svg";